export enum AuthenticationProvider {
  CYBERSOURCE = 0,
  POWERTRANZ = 1
}
